"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPDATE_EXPANDED_IDS = exports.UPDATE_ENABLED_IDS = exports.TOGGLE = exports.EXPAND_ALL = exports.COLLAPSE_ALL = void 0;
var COLLAPSE_ALL = 'collapseAll';
exports.COLLAPSE_ALL = COLLAPSE_ALL;
var EXPAND_ALL = 'expandAll';
exports.EXPAND_ALL = EXPAND_ALL;
var TOGGLE = 'toggle';
exports.TOGGLE = TOGGLE;
var UPDATE_ENABLED_IDS = 'updateEnabledIds';
exports.UPDATE_ENABLED_IDS = UPDATE_ENABLED_IDS;
var UPDATE_EXPANDED_IDS = 'updateExpandedIds';
exports.UPDATE_EXPANDED_IDS = UPDATE_EXPANDED_IDS;